import React from 'react';
import { ChevronLeftIcon, ChevronRightIcon } from '@heroicons/react/24/outline';
export function Pagination({ pagination, onPageChange }) {
  if (!pagination || pagination.pages <= 1) return null;
  const { page, pages, total, limit } = pagination;
  const start = (page-1)*limit+1, end = Math.min(page*limit, total);
  const nums = Array.from({ length: Math.min(pages,5) }, (_,i) => i+1);
  return (
    <div className="flex items-center justify-between px-4 py-3 border-t border-gray-100 text-sm">
      <p className="text-gray-400 text-xs">Showing {start}–{end} of {total}</p>
      <div className="flex gap-1">
        <button onClick={()=>onPageChange(page-1)} disabled={page===1} className="p-1.5 rounded-lg hover:bg-gray-100 disabled:opacity-30 transition-colors"><ChevronLeftIcon className="w-4 h-4"/></button>
        {nums.map(p => <button key={p} onClick={()=>onPageChange(p)} className={'w-8 h-8 rounded-lg font-medium text-xs transition-colors ' + (p===page ? 'bg-indigo-600 text-white' : 'hover:bg-gray-100 text-gray-600')}>{p}</button>)}
        <button onClick={()=>onPageChange(page+1)} disabled={page===pages} className="p-1.5 rounded-lg hover:bg-gray-100 disabled:opacity-30 transition-colors"><ChevronRightIcon className="w-4 h-4"/></button>
      </div>
    </div>
  );
}